// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 00:13:34

export default {
  "id": "gun-racing",
  "slug": "gun-racing",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/f1d26823646c4078a6db03221f8e05d1-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/f1d26823646c4078a6db03221f8e05d1/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Gun Racing",
      "description": "Here you cannot just race with other cars, but destroy them with the help of numerous weapons. Improve your riding skills and take first places in tournaments!",
      "instructions": "Pass the skill test levels and unlock new content!\n\nFor completing a level you are given money and tickets, for which you can buy and improve weapons and cars.\nFor completing the grand tournament and timed battles, increased rewards are given out!\nAlso, for completing the game, experience is awarded, which unlocks bonuses in the seasons. For 25 experience levels you are guaranteed to get a new car!",
      "genres": [
        "Casual",
        "Racing & Driving"
      ],
      "tags": [
        "3d",
        "boys"
      ]
    },
    "zh-CN": {
      "title": "枪战赛车",
      "description": "在这里，你不仅可以用其他汽车进行竞速，还能借助众多武器将它们摧毁。提升你的驾驶技巧，在锦标赛中取得第一名！",
      "instructions": "通过技能测试关卡，解锁新内容！\n\n完成关卡后，您将获得金钱和门票，您可以用它们购买和升级武器和汽车。\n完成大锦标赛和计时战斗后，将发放更高的奖励！\n此外，完成游戏后，您将获得经验值，这将在季节中解锁奖励。对于25个经验等级，您将确保获得一辆新车！",
      "genres": [
        "休闲",
        "赛车与驾驶"
      ],
      "tags": [
        "3D",
        "少年"
      ]
    },
    "zh-TW": {
      "title": "槍戰賽車",
      "description": "這裡您不僅可以和其他車輛競賽，還可以借助眾多武器將它們擊毀。提升您的駕馭技巧，在比賽中奪得第一名！",
      "instructions": "通過技能測試等級以解锁新內容！\n\n完成等級後，你將獲得錢幣和票券，用於購買和提升武器與車輛。\n完成大賽和時間戰鬥，將提供增加的獎勵！\n此外，完成遊戲後，將獲得經驗值，可在季節中解锁獎勵。對於25個經驗等級，你將確保獲得一款新車！",
      "genres": [
        "休闲",
        "賽車與駕駛"
      ],
      "tags": [
        "3D",
        "男孩們"
      ]
    },
    "zh-HK": {
      "title": "槍戰賽車",
      "description": "這裡你不但可以與其他車輛競賽，更可憑藉眾多武器將對手擊毀。提升你的駕馭技巧，在賽事中奪得冠軍！",
      "instructions": "通過技能測試等級，解鎖新內容！\n\n完成一個等級，你將獲得金錢和車票，可用來購買和提升武器及車輛。\n完成大賽及時間戰鬥，將提供更多獎勵！\n此外，完成遊戲後，將獲得經驗值，可用於在季節中解鎖獎勵。25個經驗等級保證你將獲得新車！",
      "genres": [
        "隨意",
        "賽車及駕駛"
      ],
      "tags": [
        "3D",
        "男子"
      ]
    },
    "ja": {
      "title": "ガンレーシング",
      "description": "ここでは他の車とただレースするだけでなく、数々の武器の助けにより壊していくことができます。あなたの運転スキルを向上させ、トーナメントで一位を獲得しよう！",
      "instructions": "スキルテストのレベルをクリアし、新しいコンテンツを解禁します！\n\nレベルをクリアすると、お金とチケットがもらえます。これらを使って武器や車を購入・強化できます。\n大大会やタイムバトルをクリアすると、増量された報酬がもらえます！\nまた、ゲームをクリアすると、季節のボーナスを解禁する経験値がもらえます。25の経験値レベルを達成すると、新しい車を確実に手に入れることができます！",
      "genres": [
        "カジュアル",
        "レース＆ドライビング"
      ],
      "tags": [
        "3D",
        "ボーイズ"
      ]
    },
    "ko": {
      "title": "건 레이싱",
      "description": "여기서 다른 차와 단순히 경주를 하지 않고, 다양한 무기로 그를 파괴할 수 있습니다. 타기의 기술을 향상시키고, 토너먼트에서 1위를 차지하세요!",
      "instructions": "스킬 테스트 레벨을 통과하고 새로운 콘텐츠를 해금하세요!\n\n레벨을 완료하면 돈과 티켓을 받을 수 있으며, 이를 통해 무기를 구매하고 개선할 수 있습니다.\n대회와 타이머 전투를 완료하면 더 높은 보상이 주어집니다!\n또한, 게임을 완료하면 시즌에서 보너스를 해금하는 경험치가 주어집니다. 25 경험치 레벨을 달성하면 새로운 차를 보장받습니다!",
      "genres": [
        "캐주얼",
        "레이싱 & 드라이빙"
      ],
      "tags": [
        "3D",
        "남자아이들"
      ]
    },
    "fr": {
      "title": "Course à Armes",
      "description": "Ici, vous ne pouvez pas seulement courir contre d'autres voitures, mais les détruire avec l'aide de nombreuses armes. Améliorez vos compétences en pilotage et gagnez les premières places dans les tournois !",
      "instructions": "Passer les niveaux du test de compétence et débloquer du contenu nouveau !\n\nPour terminer un niveau, vous recevez de l'argent et des billets, avec lesquels vous pouvez acheter et améliorer des armes et des voitures.\nPour terminer le grand tournoi et les batailles à temps, des récompenses accrues sont attribuées !\nDe plus, pour terminer le jeu, de l'expérience est attribuée, ce qui débloque des bonus dans les saisons. Pour 25 niveaux d'expérience, vous êtes assuré de recevoir une nouvelle voiture !",
      "genres": [
        "Facile",
        "Course et Conduite"
      ],
      "tags": [
        "3D",
        "garçons"
      ]
    }
  }
};
